import store from '@core/store/store';
import createApiInstance from '@core/utils/api/custom.instance';
        
export async function handling_erorr_401 (is_alert_duplicate_login, i18n) {
    if (!is_alert_duplicate_login) {
        alert(i18n.t('다중 로그인 등 권한 오류가 발생했습니다. 다시 로그인해 주십시오.'));
    }
    
    await store.dispatch('logout');
    window.location.href = '/';
    localStorage.setItem('is_alert_duplicate_login', 1);
}

export function makeProjectAxios(i18n){
    // client_id 기본 파라미터는 죽은 계약이라 제거 — 백엔드(projects_bp)는 어디서도 읽지 않고
    // 다원청 접근제어는 서버측 DashboardViewer ACL 이 담당한다 (2026-09-01 의도 규명).
    const axiosInstance = createApiInstance('projects');
    
    axiosInstance.interceptors.response.use((res) => res,(error) => {
        if (error.response) {
            if (process.env.VUE_APP_BUILD_ENV !== 'production') {
                console.log(' 		~ error.response => ', error.response);
                console.log(' 		~ error.response.status => ', error.response.status);
            }
            
            if (error.response.status === 401) {
                const is_alert_duplicate_login = localStorage.getItem('is_alert_duplicate_login');
                handling_erorr_401(is_alert_duplicate_login, i18n);
                return Promise.reject(error);
            } else {
                return Promise.reject(error);
            }
        } else {
            return Promise.reject(error);
        }
    });
    return axiosInstance;
}
